export default __webpack_public_path__ + "static/media/pie_chart_dark.ad530864.svg";